import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-sources',
  templateUrl: './help-sources.component.html',
  styleUrls: ['./help-sources.component.scss']
})
export class HelpSourcesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
